<template lang="pug">
transition(name="ease-in-out")
  div(
    v-bind:style="menuPosition"
    v-show="isDisplay"
    id="context-menu-data" 
    ref="contextMenuData"
    v-click-outside="closeMenu")
      div.item(@click="editCategory") 
        i.material-icons edit
        span.menu-item Edit Tag
      div.item(@click="toggleStatus") 
        i.fa.fa-random
        span.menu-item(ref="status") Enable
      hr.border-menu
      div.item 
        i.material-icons add_box
        span.menu-item.action 
          | Create Tag
          i.material-icons chevron_right

          div.action-menu
            div.item(@click="createCategory(1)") 
              i.fa.fa-sort-amount-desc
              span.menu-item Same Level
            div.item(@click="createCategory(2)") 
              i.fa.fa-sort-amount-asc
              span.menu-item Sub Level
</template>

<script>
export default {
    data() {
        return {
            isDisplay: false,
            selectedCategory: null,
            isEnable: true,
            menuPosition: {
                top: 0,
                left: 0,
            },
            toggleStatusApi: Laroute.route(
                'franchise.inventory.tags.toggle-status',
            ),
        };
    },

    created() {
        this.registerEvent();
    },

    beforeDestroy() {
        this.$bus.$off('category_menu::toggle-menu');
    },

    methods: {
        registerEvent() {
            this.$bus.$on('category_menu::toggle-menu', data => {
                const { event, model, bound } = data;
                this.openMenu();
                this.selectedCategory = model;
                this.changeStatusName(model);
                this.setMenuPosition(bound);
            });
        },

        closeMenu() {
            this.isDisplay = false;
        },

        openMenu() {
            this.isDisplay = true;
        },

        setMenuPosition(bound) {
            const { top, left, x, y } = bound;
            let leftPos = left + 55;
            let topPos = top + 20;

            this.menuPosition.top = `${topPos}px`;
            this.menuPosition.left = `${leftPos}px`;
        },

        changeStatusName(model) {
            this.$refs.status.innerHTML = model.disabled ? 'Enable' : 'Disable';
        },

        editCategory() {
            this.$bus.$emit('manage_tag::show_form', this.selectedCategory);
        },

        // INFO:: 1 - for SAME LEVEL
        // INFO:: 2 - for CHILD LEVEL
        createCategory(type) {
            this.$bus.$emit(
                'manage_tag::show_form',
                this.selectedCategory,
                type,
            );
        },

        async toggleStatus() {
            const response = await axios
                .post(this.toggleStatusApi, {
                    id: this.selectedCategory.id,
                    status: this.selectedCategory.disabled ? 1 : 0,
                })
                .catch(e => console.log(e));

            if (response) {
                this.isDisplay = false;
                toastr.success(`Status Updated`);
                this.$bus.$emit('category_tree::rebuild');
            }
        },
    },
};
</script>

<style lang="scss">
#context-menu-data {
    position: absolute;
    z-index: 100000;
    width: 250px;
    background: rgb(255, 255, 255);
    border-radius: 8px;
    box-shadow: 0px 0px 10px 0px #d7d7d7;

    .item {
        margin: 0.6rem 0.5rem;
        padding: 0.5rem 0.5rem;
        font-size: 14px;
        font-weight: 500;
        color: rgb(65, 65, 65);
        cursor: pointer;
        border-radius: 4px;
        display: flex;
        flex-direction: row;
        align-content: center;
        align-items: center;

        &:hover {
            background: #efefef;
        }

        .menu-item {
            margin-left: 0.8rem;

            &.action {
                display: flex;
                width: 100%;
                justify-content: space-between;
                position: relative;

                .action-menu {
                    border-radius: 8px;
                    position: absolute;
                    background-color: #fff;
                    margin-left: 200px;
                    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.08);
                    margin-top: -15px;
                    width: 250px;
                    opacity: 0;
                    transition: 0.2s ease;
                }

                &:hover > .action-menu {
                    opacity: 1;
                    pointer-events: auto;
                }
            }
        }
    }

    .border-menu {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }
}

.ease-in-out-enter-active,
.ease-in-out-leave-active {
    transform-origin: top left;
    transform: scale(1);
    transition: transform 200ms ease-in-out;
}
.ease-in-out-enter,
.ease-in-out-leave-to {
    transform: scale(0);
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tag/category-menu.vue